import { SimpleCard } from '@exxonmobil/standard';
import { InternalTeamCardValidation } from '../types/InternalTeamCardTypes';
import '../styles/internalteamcard.css';

const InternalTeamCard = ({ data }: InternalTeamCardValidation) => {
  return <SimpleCard description={data.description} headline={data.name} optionalClass='internal-team-card'/>;
};

export default InternalTeamCard;
